const initialState = {
   account: {},
   inProgressPlansFetching: true,
   inProgress: true,
   plans: {},
   isProgressBilling: false,
};

export default initialState;
